import { toast } from "react-toastify";
import { TimeAutocomplete } from "./TimeAutocomplete";

interface Props {
  hour: string;
  setHour: (newHour: string) => void;
  disabled?: boolean;
}

const hourList = Array.from({ length: 24 }, (_, index) =>
  (index).toString()
);

const candidateMap: { [key: string]: string } = {};
hourList.forEach((time) => {
  candidateMap[time] = time;
});

export const Search24Hour: React.FC<Props> = ({ hour, setHour, disabled }) => {
  const handleChangeTextField = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.value !== "") {
      const newTime = Number(event.target.value);

      if (isNaN(newTime)) {
        toast.error("숫자만 입력 가능합니다.");
        setHour("");
        return;
      } else if (newTime < 0 || newTime > 23) {
        toast.error("0 ~ 23 사이의 숫자만 입력 가능합니다.");
        setHour("");
        return;
      }
    }
    setHour(event.target.value);
  };

  return (
    <TimeAutocomplete
      width="84px"
      placeholder="00"
      value={hour}
      candidateMap={candidateMap}
      onClickSelectItem={(key: string) => setHour(key)}
      onChangeTextField={handleChangeTextField}
      isActive={hour !== ""}
      disabled={disabled}
    />
  );
};
